import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import { Grid, IconButton } from "@mui/material";
import ApolloShortModal from "../ApolloShortModal/ApolloShortModal";

const ApolloShortRoutine = ({ routine }) => {
  const { Subject, Chapter } = routine;
  //   const theme = useTheme();
  const [openRoutine, setOpenRoutine] = React.useState(false);
  const handleRoutineOpen = () => setOpenRoutine(true);
  const handleRoutineClose = () => setOpenRoutine(false);
  return (
    <>
      <Grid item xs={12} md={4} sm={6}>
        <Card sx={{ maxWidth: " 300px" }}>
          <CardMedia
            component="img"
            alt="😀 Error"
            height="140"
            image="https://i.ibb.co/NTBkcjx/245635992-1088903411846888-7434903865561951096-n.jpg"
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {Chapter}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {Subject}
            </Typography>
          </CardContent>
          <CardActions>
            <IconButton
              onClick={handleRoutineOpen}
              aria-label="watch"
              size="large"
            >
              <VisibilityRoundedIcon
                sx={{
                  "&:hover": {
                    padding: "14px",
                    borderRadius: "50%",
                  },
                }}
                fontSize="inherit"
              />
            </IconButton>
          </CardActions>
        </Card>
      </Grid>
      <ApolloShortModal
        routine={routine}
        handleRoutineClose={handleRoutineClose}
        openRoutine={openRoutine}
      ></ApolloShortModal>
    </>
  );
};

export default ApolloShortRoutine;
